// src/App.js
import React from "react";
import "flag-icon-css/css/flag-icons.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BookTablePage from "./pages/BookTablePage";
import PrivateEventsPage from "./pages/PrivateEventsPage";
import OrderPage from "./pages/OrderPage";
import ContactPage from "./pages/ContactPage";
import BuffetBookingPage from "./pages/BuffetBookingPage";
import OrderTracking from "./pages/OrderTracking";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { CartProvider } from "./context/CartContext";
import { UserProvider } from "./context/UserContext";
import { CheckoutProvider } from "./context/CheckoutContext";
// import CheckoutModalWrapper from "./components/CheckoutModalWrapper";

import PaymentSuccess from "./pages/PaymentSuccess";
import LasgidiGotTalent from "./pages/LasgidiGotTalent";
import WelcomePopup from "./components/WelcomePopup";
import PollModal from "./components/PollModal";
import MobileBasketBar from "./components/MobileBasketBar";
// import LoyaltyPopup from "./components/LoyaltyPopup";
import Checkout from "./pages/Checkout";
import Profile from "./pages/ProfilePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";

function App() {
  return (
    <UserProvider>
        <CheckoutProvider>
          <CartProvider>
            <Router>
              <ScrollToTop />
              <AnalyticsTracker />
                <WelcomePopup />
                <PollModal />
                {/* <LoyaltyPopup /> */}
              <Navbar />
              <div className="flex-1 flex flex-col">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/book-table" element={<BookTablePage />} />
                  <Route path="/private-events" element={<PrivateEventsPage />} />
                  <Route path="/order-online" element={<OrderPage />} />
                  <Route path="/buffet" element={<BuffetBookingPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/lasgidi-got-talent" element={<LasgidiGotTalent />} />
                  <Route path="/order-tracking" element={<OrderTracking />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/profile" element={<Profile />} />
                </Routes>
              </div>
              <Footer />
              <MobileBasketBar />
              {/* <CheckoutModalWrapper /> */}
            </Router>
          </CartProvider>
        </CheckoutProvider>
    </UserProvider>
  );
}

export default App;
